import React from 'react';


export const Athena = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/athena.png')} />
    )
};
